// tslint:disable: max-line-length
import React, { useEffect, useState } from 'react';
import Block from 'lqa-ui/lib/Components/Block';
import './styles.scss';
import { getItem } from '../../utils/localStorage';
import Donut from 'lqa-ui/lib/Components/Donut';
import moment from 'moment';
import LoadingContent from 'lqa-ui/lib/Components/LoadingContent';
import { GetAllDataByIndexedDB } from '../../indexed';
import { convertUTCDateDisplay } from '../../helpers/dates';

const AssessmentSeries = (props) => {
  const { assessmentData, summary, templateId } = props;
  const [categoriesData, setCategoriesData] = useState<any>([]);

  useEffect(() => {
    (async () => {
      const selectedHotel = getItem('selectedHotel');
      const templateData: any = await GetAllDataByIndexedDB(
        `/template/${templateId}`,
        selectedHotel
      );
      const duplicateCategories = assessmentData.duplicateCategories.map(
        (o) => o.templateCategoryId
      );
      let categories = templateData.category.filter(
        (o) => o.categoryType === 'category'
      );
      const subCategories = templateData.category.filter(
        (o) =>
          o.categoryType === 'subCategory' && duplicateCategories.includes(o.id)
      );
      categories = categories.map((o, i) => {
        const childs = subCategories.filter((k) =>
          o.categories.includes(k.uuid)
        );
        if (childs.length > 0) {
          return {
            ...o,
            subCategories: childs,
          };
        } else {
          categories.slice(i, 1);
        }
      });
      categories = categories.filter((item) => item !== undefined);
      setCategoriesData(categories);
    })();
  }, []);

  if (!categoriesData || categoriesData.length <= 0) {
    return <LoadingContent layout="flex" />;
  }

  return (
    <>
      {categoriesData.map((o) => {
        return (
          <Block key={assessmentData.id} className="marginBottom20 box-shadow">
            <span className="assessmtCat">
              {o.value}:
              {o.subCategories.map((subcat, index) => (
                // tslint:disable-next-line:jsx-key
                <span className="assessmtStatus">
                  {' '}
                  {subcat.value}
                  {o.subCategories && o.subCategories.length !== index + 1
                    ? ','
                    : ''}
                </span>
              ))}
            </span>
            <div className="assessDtlContainer">
              <div className="assessDtlChart">
                <Donut
                  percentage={
                    summary &&
                    summary.find(
                      (k) =>
                        k.sourceTemplateCategoryId ===
                        o.sourceTemplateCategoryId
                    ) &&
                    summary.find(
                      (k) =>
                        k.sourceTemplateCategoryId ===
                        o.sourceTemplateCategoryId
                    ).score
                      ? summary.find(
                          (k) =>
                            k.sourceTemplateCategoryId ===
                            o.sourceTemplateCategoryId
                        ).score
                      : 0
                  }
                  size={85}
                  intent={
                    summary &&
                    summary.find(
                      (k) =>
                        k.sourceTemplateCategoryId ===
                        o.sourceTemplateCategoryId
                    ) &&
                    summary.find(
                      (k) =>
                        k.sourceTemplateCategoryId ===
                        o.sourceTemplateCategoryId
                    ).score
                      ? summary.find(
                          (k) =>
                            k.sourceTemplateCategoryId ===
                            o.sourceTemplateCategoryId
                        ).score >= 80
                        ? 'success'
                        : summary.find(
                            (k) =>
                              k.sourceTemplateCategoryId ===
                              o.sourceTemplateCategoryId
                          ).score >= 50
                        ? 'warning'
                        : 'danger'
                      : 'danger'
                  }
                  decimals={1}
                  percentageSign={true}
                  changeIntent={'success'}
                />
              </div>
              <div className="assessDtlAuth">
                <span className="title">Assigned To:</span>
                <span className="name">{`${
                  assessmentData.auditor.userLastName.charAt(0).toUpperCase() +
                  assessmentData.auditor.userLastName.slice(1)
                }, ${
                  assessmentData.auditor.userFirstName.charAt(0).toUpperCase() +
                  assessmentData.auditor.userFirstName.slice(1)
                }`}</span>
              </div>
              <div className="assessDtlDate">
                <span className="title">Due Date:</span>
                <span
                  className={
                    moment(convertUTCDateDisplay(assessmentData.stayEnd)) <
                    moment(convertUTCDateDisplay(new Date().toString()))
                      ? 'date color-red'
                      : 'date color-919191'
                  }
                >
                  {moment(convertUTCDateDisplay(assessmentData.stayEnd)).format(
                    'DD MMM YY'
                  )}
                </span>
                <span className="statusCheck">
                  {`${
                    o.subCategories.filter((subcat) =>
                      assessmentData.duplicateCategories.some(
                        (i) =>
                          i.templateCategoryId === subcat.id &&
                          i.percentage >= 100
                      )
                    ).length
                  }/${o.subCategories.length} Complete`}
                </span>
              </div>
            </div>
          </Block>
        );
      })}
    </>
  );
};

export default AssessmentSeries;
